import React from 'react'
import { render } from 'react-dom'
import StyleGuide from '../StyleGuide'
;(() => {
  const container = document.getElementById('style-guide-index')
  if (!container) return

  render(<StyleGuide />, container)
})()
